// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__7y_3O","alert":"SettungsInbox_alert__3jskT"};